import axios from "../../axios/index.js"


export default {
  getAllNouvelArticle() {
    return axios.get("/nouvelArticle",
    { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getAllNouvelArticleParMagasin() {
    return axios.get("/nouvelArticleParMagasin",
    { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  getListCreationParMagasin(code){
    return axios.get("/listCreationParMagasin/" + code,
    { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
}
